import type { Location } from 'react-router-dom';

const shouldHideSignupFooter = (location: Location) => {
  const [, route] = location.pathname.split('/');
  return route === 'signup';
};

export const shouldHideFooter = (location: Location) => {
  const shouldHideManagementDashboardFooter = () => {
    // always show footer on the user details page, nested under /client
    if (/\/client\/\w{24}\/users\/\w{24}/i.test(location.pathname)) return false;

    const paths = ['/client/', '/workspace', '/ctf-builder'];
    const isPathMatched = paths.some((path) => location.pathname.includes(path));
    return isPathMatched;
  };

  return shouldHideManagementDashboardFooter() || shouldHideSignupFooter(location);
};
